export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  imageQuery: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    name: '正版同人志',
    slug: 'doujinshi',
    description: '正版授权的二次创作漫画，涵盖热门动漫IP的同人作品，画风精美，收藏价值高。',
    icon: 'ri-book-open-line',
    imageQuery: 'Japanese%20doujinshi%20manga%20book%20display%20on%20wooden%20shelf%2C%20colorful%20covers%20with%20anime%20characters%2C%20warm%20lighting%2C%20cozy%20indoor%20setting%2C%20clean%20composition%2C%20soft%20bokeh%20background%2C%20artistic%20photography%2C%20high%20quality%20book%20collection%20display',
    articleCount: 42,
  },
  {
    id: 'cat-2',
    name: '角色设定集',
    slug: 'artbooks',
    description: '官方出品的角色设定资料集，包含线稿、色彩设定、背景美术等珍贵素材。',
    icon: 'ri-palette-line',
    imageQuery: 'Anime%20art%20book%20character%20design%20collection%20open%20on%20desk%2C%20beautiful%20illustration%20pages%2C%20sketch%20drawings%20visible%2C%20soft%20natural%20light%20from%20window%2C%20warm%20wooden%20desk%20surface%2C%20artistic%20atmosphere%2C%20clean%20minimal%20composition',
    articleCount: 28,
  },
  {
    id: 'cat-3',
    name: '漫画手册',
    slug: 'comic-guides',
    description: '漫画技法教程、创作手册与行业指南，帮助爱好者提升绘画和创作能力。',
    icon: 'ri-pencil-ruler-line',
    imageQuery: 'Manga%20drawing%20guide%20book%20with%20pencil%20and%20sketch%20tools%20on%20creative%20desk%2C%20step%20by%20step%20tutorial%20pages%20visible%2C%20warm%20desk%20lamp%20lighting%2C%20cozy%20artist%20workspace%2C%20creative%20atmosphere%2C%20clean%20composition',
    articleCount: 35,
  },
  {
    id: 'cat-4',
    name: '周边收藏',
    slug: 'merchandise',
    description: '动漫周边商品收藏指南，包含限定版手办、画集、海报等稀有周边的入手攻略。',
    icon: 'ri-gift-line',
    imageQuery: 'Anime%20merchandise%20collection%20display%20shelf%20with%20figures%20and%20posters%2C%20limited%20edition%20items%2C%20organized%20glass%20cabinet%2C%20warm%20ambient%20lighting%2C%20collector%20room%20setting%2C%20clean%20minimal%20composition%2C%20high%20quality%20photography',
    articleCount: 56,
  },
  {
    id: 'cat-5',
    name: '展会指南',
    slug: 'events',
    description: 'Comic Market、ComicUp等国内外同人展会的参展攻略与战利品分享。',
    icon: 'ri-calendar-event-line',
    imageQuery: 'Anime%20comic%20convention%20event%20hall%20with%20booths%20and%20crowds%2C%20colorful%20displays%2C%20cosplayers%20in%20background%20blur%2C%20bright%20exhibition%20lighting%2C%20energetic%20atmosphere%2C%20wide%20angle%20view%2C%20clean%20composition',
    articleCount: 19,
  },
  {
    id: 'cat-6',
    name: '收藏技巧',
    slug: 'collection-tips',
    description: '同人本保存、防潮、展示、鉴定等实用收藏技巧，延长藏品寿命。',
    icon: 'ri-shield-check-line',
    imageQuery: 'Manga%20books%20carefully%20stored%20in%20protective%20sleeves%20on%20bookshelf%2C%20archival%20quality%20storage%2C%20neatly%20organized%20collection%2C%20warm%20home%20library%20setting%2C%20soft%20indoor%20lighting%2C%20clean%20composition%2C%20detailed%20close%20up',
    articleCount: 24,
  },
];